import travelTrailer from "@/assets/rv-placeholders/travel-trailer.webp";
import fifthWheel from "@/assets/rv-placeholders/fifth-wheel.webp";
import toyHauler from "@/assets/rv-placeholders/toy-hauler.webp";
import classA from "@/assets/rv-placeholders/class-a.webp";
import classB from "@/assets/rv-placeholders/class-b.webp";
import classC from "@/assets/rv-placeholders/class-c.webp";
import generic from "@/assets/rv-placeholders/generic.jpg";
import { placeholderCategory } from "./rvPhotoPolicy";

const graphics: Record<string, string> = {
  "travel-trailer": travelTrailer, "fifth-wheel": fifthWheel, "toy-hauler": toyHauler,
  "class-a": classA, "class-b": classB, "class-c": classC, generic,
};

export function rvPlaceholder(type?: string | null): string {
  return graphics[placeholderCategory(type)] ?? generic;
}